import { render, staticRenderFns } from "./SaveOrderFormSkeleton.vue?vue&type=template&id=521c2f20&"
import script from "./SaveOrderFormSkeleton.vue?vue&type=script&lang=js&"
export * from "./SaveOrderFormSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports